<rid-demo-page [title]="'Ja of nee'" previousRoute="/mechanics/sorting">
  <rid-button class="w-full" content="Sorteren | Ja of nee (gemengd)" variant="PRIMARY" routerLink="mixed" />

  <br />

  <rid-button class="w-full" content="Sorteren | Ja of nee (dubbel woord)" variant="PRIMARY" routerLink="double-word" />
  <rid-button class="w-full" content="Sorteren | Ja of nee (audio)" variant="PRIMARY" routerLink="audio" />
  <rid-button class="w-full" content="Sorteren | Ja of nee (enkel woord)" variant="PRIMARY" routerLink="word" />
  <rid-button class="w-full" content="Sorteren | Ja of nee (zin)" variant="PRIMARY" routerLink="sentence" />
</rid-demo-page>
